import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#6750A4',
        },
        secondary: {
            main: '#625B71',
        },
        background: {
            default: '#FEFBFF',
        },
        text: {
            primary: '#1C1B1F',
            secondary: '#49454F',
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#F5F3FF', // light purple
                    margin: 0,
                    padding: 0,
                },
                ':root': {
                    '--login-card-bg': '#fff',
                    '--login-bg': '#FEFBFF',
                    '--primary-color': '#132f5f',
                    '--input-label-color': '#49454f',
                    '--input-text-color': '#1d1b20',
                    '--border-radius': '16px',
                    '--button-radius': '8px',
                    '--button-font-size': '14px',
                    '--input-icon-size': '22px',
                },
            },
        },
    },
    shape: {
        borderRadius: 16,
    },
    typography: {
        fontFamily: 'Poppins, sans-serif',
        button: {
            fontSize: '14px',
            fontWeight: 500,
        },
    },
});

export default theme;
